import { render, staticRenderFns } from "./TakipSorgulaFormWizard.vue?vue&type=template&id=6b858dea"
import script from "./TakipSorgulaFormWizard.vue?vue&type=script&lang=ts"
export * from "./TakipSorgulaFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports